import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const createCheckoutSplitGeneration = {
  name: "createCheckoutSplitGeneration" as const,
  input: z.object({
    parentSplitId: zExt.objectId(),
    selectedTreatmentId: zExt.objectId(),
  }),
  output: z.object({ newSplitId: zExt.objectId() }),
};
